import type { UserOutput } from "@orsane/schema/users";
import avatarUrl from "@/lib/image-urls";
import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";

export function userFallbackColor(user: UserOutput) {
    const initials = user.name.charAt(0);
    const chars = initials.toUpperCase().replace(/[^A-Z]/g, "");

    let hue = 0;
    for (let i = 0; i < chars.length; i++) {
        hue += (chars.charCodeAt(i) - 65) * (360 / 26) * (i + 1);
    }
    hue = hue % 360;

    // Almost Pastel colors: low saturation, high lightness
    return `hsl(${hue}, 50%, 60%)`;
}

export function UserAvatar({ user, size }: { user: UserOutput; size: "xs" | "sm" | "md" | "lg" }) {
    let avatarSize = "40" as "40" | "70" | "original";
    switch (size) {
        case "xs":
            avatarSize = "40";
            break;
        case "sm":
            avatarSize = "40";
            break;
        case "md":
            avatarSize = "40";
            break;
        case "lg":
            avatarSize = "70";
            break;
    }
    return (
        <Avatar
            className={cn(
                size === "xs" && "size-5",
                size === "sm" && "size-5.5",
                size === "md" && "size-8",
                size === "lg" && "size-9"
            )}
        >
            <AvatarImage src={avatarUrl(user.image, avatarSize)} alt={user.name} />
            <AvatarFallback
                delay={700}
                className={cn({
                    "text-[11px]": size === "xs",
                    "text-sm": size === "sm",
                    "text-lg": size === "md" || size === "lg",
                })}
                style={{ backgroundColor: userFallbackColor(user) }}
            >
                <span className="text-white opacity-80">{user.name.charAt(0)}</span>
            </AvatarFallback>
        </Avatar>
    );
}
